$.fn.extend
  textsContainer: (options) ->
    input = 
      option1: "red"
    
    input = $.extend input, options

    # console.log settings.frames

    container = $(@)

    output = {
    
        insert: (text) ->
          $.ajax(
            dataType: 'JSON'
            method: 'POST'
            data:
              app_url: window.location.pathname
              text: text
            url: '/ajax/app/text_insert/'
          ).done((data) ->
              console.log data
              $('#active_text').val(data.object_id)
              output.reload(data.object_id)
              loadPage()

              return
          ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
          return

        reload: (object_id) ->
            showSmallLoader()
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              url: '/ajax/app/texts_container/'
              data: 
                app_url: window.location.pathname
                object_id: object_id
            ).done((data) ->
                hideSmallLoader()
                $('#active_text').val(object_id)
                if data.status
                  container.html data.html_output
                  return
            ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
            return 


            
    }

    # output.reload()

    return output